import { Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Button from "../../Component/Common/Button";
import Input from "../../Component/Common/Input";
import { useNavigate } from "react-router-dom";
import { razorpay_api_key } from "../../util/config";
import { getAmountInSubunits } from "../../util/RazorpayCurrency";
import {
  completeSubscription,
  createOrgDetails,
  getOrgUserProfile,
  getSubscriptionPlans,
  resetPassword,
} from "../../store/organization/organization.action";
import { useDispatch } from "react-redux";
import { uploadFile } from "../../util/AwsFunction";
import { SubscriptionCard } from "../../Component/Common/SubscriptionCard";
import { applyCouponCode } from "../../store/coupon/coupon.action";
import dayjs from "dayjs";
import { apiInstance } from "../../util/api-new";

const Onboarding = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeStep, setActiveStep] = useState(0);

  const [subscriptionPlans, setSubscriptionPlans] = useState([]);

  const [member, setMember] = useState();
  const [isOrgBoarded, setIsOrgBoarded] = useState(true);

  const [memberName, setMemberName] = useState();
  const [memberEmail, setMemberEmail] = useState();
  const [profileImageFile, setProfileImageFile] = useState();
  const [profileImage, setProfileImage] = useState();

  const [orgId, setOrgId] = useState();
  const [orgUniqueId, setOrgUniqueId] = useState();
  const [organizationName, setOrganizationName] = useState("");
  const [organizationEmail, setOrganizationEmail] = useState("");
  const [organizationWebsite, setOrganizationWebsite] = useState("");
  const [organizationPhone, setOrganizationPhone] = useState("");
  const [logoFile, setLogoFile] = useState();
  const [logoImage, setLogoImage] = useState("");
  const [organizationAddress, setOrganizationAddress] = useState({
    street: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
  });

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [selectedPlan, setselectedPlan] = useState(null);

  const [couponCode, setCouponCode] = useState();
  const [appliedCoupon, setAppliedCoupon] = useState(null);

  const [errors, setErrors] = useState({});

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleApplyCouponCode = async () => {
    if (couponCode) {
      const res = await applyCouponCode(
        couponCode,
        selectedPlan._id,
        orgId,
        selectedPlan.pricing.amount,
      );

      setAppliedCoupon(res.data || null);
      setCouponCode("");
    }
  };

  const reApplyCouponCodeOnPlanChange = async () => {
    if (appliedCoupon) {
      const res = await applyCouponCode(
        appliedCoupon.coupon.code,
        selectedPlan._id,
        orgId,
        selectedPlan.pricing.amount,
      );

      setAppliedCoupon(res.data || null);
      setCouponCode("");
    }
  };

  const handleRemoveCoupon = () => {
    setAppliedCoupon(null);
    setCouponCode("");
  };

  const handlePayment = () => {
    if (selectedPlan) {
      const options = {
        key: razorpay_api_key,
        amount: getAmountInSubunits(
          appliedCoupon
            ? appliedCoupon.finalAmount
            : selectedPlan.pricing.amount,
          selectedPlan.pricing.currency,
        ),
        currency: selectedPlan.pricing.currency,
        name: "Care Tube",
        description: "Care Tube",
        image: "../../assets/images/MetubeLogo.png",
        handler: async function (response) {
          const payload = {
            planId: selectedPlan._id,
            razorpayPaymentId: response.razorpay_payment_id,
            couponData: appliedCoupon
              ? {
                  couponId: appliedCoupon.coupon._id,
                  originalAmount: appliedCoupon.originalAmount,
                  discountAmount: appliedCoupon.discountAmount,
                  finalAmount: appliedCoupon.finalAmount,
                }
              : null,
            paymentDetails: {
              amount: selectedPlan.pricing.amount,
              currency: selectedPlan.pricing.currency,
              currencySymbol: selectedPlan.pricing.currencySymbol,
              paymentGateway: "razorpay",
              transactionId: response.razorpay_payment_id,
              orderId: response.razorpay_order_id,
              billingAddress: {
                name: organizationName,
                email: organizationEmail,
                phone: organizationPhone,
                address: organizationAddress,
              },
            },
          };

          let startDate, endDate;
          startDate = dayjs().toDate();
          endDate = dayjs()
            .add(selectedPlan.billingCycle == "yearly" ? 365 : 30, "days")
            .subtract(1, "day")
            .endOf("day")
            .toDate();

          payload.startDate = startDate;
          payload.endDate = endDate;

          const res = await completeSubscription(payload);

          if (res) {
            navigate("/org/members", { replace: true });
          }
        },
        prefill: {
          name: organizationName,
          email: organizationEmail,
        },
        notes: {
          ...(appliedCoupon && {
            couponId: appliedCoupon.coupon._id,
            originalAmount: appliedCoupon.originalAmount,
            discountAmount: appliedCoupon.discountAmount,
            finalAmount: appliedCoupon.finalAmount,
          }),
        },
        theme: {
          color: "#ff4d67",
        },
        modal: {
          ondismiss: function () {},
        },
      };

      const rzp = new Razorpay(options);

      rzp.on("payment.failed", function (response) {
        console.error("Payment Error:", response.error);
      });

      rzp.open();
    }
  };

  const handleStartFreeTrial = () => {
    let startDate, endDate;
    startDate = dayjs().toDate();
    endDate = dayjs()
      .add(selectedPlan.trialDays, "days")
      .subtract(1, "day")
      .endOf("day")
      .toDate();

    const payload = {
      planId: selectedPlan._id,
      startDate,
      endDate,
    };

    apiInstance
      .post("organization/subscription/free-trial", payload)
      .then((res) => {
        if (res.status) {
          navigate("/org/members", { replace: true });
        }
      });
  };

  const handleNextClick = async () => {
    if (activeStep == 0) {
      const error = {};
      if (!newPassword || !confirmPassword) {
        if (!newPassword) {
          error.password = "Password is required!";
        }
        if (!confirmPassword) {
          error.confirmPassword = "Password is required!";
        }
        setErrors(error);
        return;
      }

      if (newPassword !== confirmPassword) {
        setErrors({ confirmPassword: "Password does not match!" });
        return;
      }

      const payload = {
        newPassword: newPassword,
        confirmPassword: confirmPassword,
      };
      console.log("RESET PASSWORD", payload);

      const res = dispatch(resetPassword(payload));
      if (res) {
        setErrors({});
        handleNext();
      }
    } else if (activeStep == 1) {
      const error = {};
      if (!memberName) {
        error.memberName = "Name is required!";
        setErrors(error);
        return;
      }

      if (organizationPhone && organizationPhone.length < 10) {
        setErrors((prev) => ({
          ...prev,
          phone: "Phone Number Must be 10 digits",
        }));
        return;
      }

      let logoUrl = "";
      let profileImageUrl = "";

      if (profileImageFile) {
        const { resDataUrl } = await uploadFile(
          profileImageFile,
          `organization/member/${member._id}`,
        );
        profileImageUrl = resDataUrl;
      }

      if (logoFile) {
        const { resDataUrl } = await uploadFile(
          logoFile,
          `organization/${orgUniqueId}`,
        );
        logoUrl = resDataUrl;
      }

      const payload = {
        member: {
          name: memberName,
          email: memberEmail,
          profileImage: profileImageUrl || profileImage,
        },
        org: {
          name: organizationName,
          website: organizationWebsite,
          phone: organizationPhone,
          logo: logoUrl || logoImage,
          address: organizationAddress,
          email: organizationEmail,
        },
        memberRole: member.role,
        isOrgBoarded: isOrgBoarded,
      };

      console.log("ORG REGISTER", payload);

      const res = dispatch(createOrgDetails(payload));
      if (res) {
        if (isOrgBoarded) {
          navigate("/org/dashboard", { replace: true });
        } else {
          setErrors({});
          handleNext();
        }
      }
    } else if (activeStep == 2) {
      handlePayment();
    }
  };

  const handleProfileImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfileImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleLogoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLogoFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchOrgDetail = async () => {
    const data = await getOrgUserProfile();
    const org = data.organization;
    const user = data.user;

    if (org && user) {
      if (
        org.registrationStatus === "COMPLETED" &&
        user.invitationStatus === "joined" &&
        user.name
      ) {
        navigate("/org/dashboard", { replace: true });
      }

      setMember(user);
      setIsOrgBoarded(org.isOnboarded);

      setMemberName(user.name);
      setMemberEmail(user.email);
      setProfileImage(user.profileImage);

      setOrgId(org._id);
      setOrgUniqueId(org.uniqueId);
      setOrganizationName(org.name);
      setOrganizationEmail(org.email);
      setOrganizationPhone(org.phone);
      setLogoImage(org.logo);
      setOrganizationWebsite(org.website);
      setOrganizationAddress(
        org.address || {
          street: "",
          city: "",
          state: "",
          country: "",
          postalCode: "",
        },
      );

      if (user.role === "org_owner") {
        if (user.invitationStatus === "invited") {
          setActiveStep(0);
        } else if (user.invitationStatus === "inprogress") {
          setActiveStep(1);
        } else if (
          org.registrationStatus === "PENDING_SUBSCRIPTION" ||
          org.registrationStatus === "COMPLETED"
        ) {
          setActiveStep(2);
        }
      } else {
        if (user.invitationStatus === "invited") {
          setActiveStep(0);
        } else if (user.invitationStatus === "inprogress") {
          setActiveStep(1);
        }
      }
    } else {
      navigate("/org/login", { replace: true });
    }
  };

  const fetchSubscriptionPlans = async () => {
    const plans = await getSubscriptionPlans();
    setselectedPlan(plans[0] || null);
    setSubscriptionPlans(plans);
  };

  useEffect(() => {
    fetchOrgDetail();
    fetchSubscriptionPlans();
  }, []);

  useEffect(() => {
    reApplyCouponCodeOnPlanChange();
  }, [selectedPlan]);

  return (
    <div className="vh-100 py-4 d-flex align-items-center justify-content-center">
      <div className="h-100 overflow-y-auto container p-4 border rounded-5 onboarding">
        <h2 className="mb-4">Profile</h2>
        <Stepper alternativeLabel activeStep={activeStep}>
          <Step>
            <StepLabel>Reset Password</StepLabel>
          </Step>
          <Step>
            <StepLabel>Profile</StepLabel>
          </Step>
          {!isOrgBoarded && (
            <Step>
              <StepLabel>Choose Plan</StepLabel>
            </Step>
          )}
        </Stepper>
        <form>
          {/* Step 1 */}
          {activeStep === 0 && (
            <div className="row row-gap-4 py-4">
              <div className="col-12 col-md-6">
                <Input
                  label="New Password"
                  type="password"
                  placeholder="Enter New Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  errorMessage={errors.password}
                />
              </div>
              <div className="col-12 col-md-6">
                <Input
                  label="Confirm Password"
                  type="password"
                  placeholder="Enter Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  errorMessage={errors.confirmPassword}
                />
              </div>
            </div>
          )}

          {/* Step 2 */}
          {activeStep === 1 && (
            <div className="row row-gap-4 py-4">
              <Typography variant="h5" component="h6" className="text-center">
                Personal Information
              </Typography>
              <div className="col-12 col-md-6">
                <Input
                  label="Name"
                  placeholder="Enter Name"
                  value={memberName}
                  onChange={(e) => setMemberName(e.target.value)}
                  errorMessage={errors.memberName}
                />
              </div>
              <div className="col-12 col-md-6">
                <Input
                  disabled
                  label="Email"
                  placeholder="Enter Email"
                  value={memberEmail}
                  onChange={(e) => setMemberEmail(e.target.value)}
                />
              </div>

              <div className="col-12 col-md-6">
                <Input
                  type={"file"}
                  label={"Profile Image"}
                  accept={"image/png, image/jpeg"}
                  // errorMessage={errors.thumbnail && errors.thumbnail}
                  onChange={handleProfileImageUpload}
                />
                {profileImage && (
                  <img
                    src={profileImage}
                    alt="org_logo"
                    height={50}
                    className="m-2"
                  />
                )}
              </div>
              {member.role === "org_admin" && !isOrgBoarded ? (
                <>
                  <div className="col-12">
                    <br />
                    <br />
                  </div>
                  <Typography
                    variant="h5"
                    component="h6"
                    className="text-center"
                  >
                    Organization Information
                  </Typography>
                  <div className="col-12 col-md-6">
                    <Input
                      label="Name"
                      placeholder="Enter Name"
                      value={organizationName}
                      onChange={(e) => setOrganizationName(e.target.value)}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <Input
                      label="Website"
                      placeholder="Enter Website"
                      value={organizationWebsite}
                      onChange={(e) => setOrganizationWebsite(e.target.value)}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <Input
                      label="Phone"
                      type="number"
                      placeholder="Enter Phone"
                      value={organizationPhone}
                      onChange={(e) => {
                        e.target.value.length == 10
                          ? setErrors((prev) => ({ ...prev, phone: "" }))
                          : null;
                        e.target.value.length <= 10
                          ? setOrganizationPhone(e.target.value)
                          : e.preventDefault();
                      }}
                      errorMessage={errors.phone && errors.phone}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <Input
                      type={"file"}
                      label={"Logo"}
                      accept={"image/png, image/jpeg"}
                      // errorMessage={errors.thumbnail && errors.thumbnail}
                      onChange={handleLogoUpload}
                    />
                    {logoImage && (
                      <img
                        src={logoImage}
                        alt="org_logo"
                        height={50}
                        className="m-2"
                      />
                    )}
                  </div>
                  <div className="col-12 custom-input">
                    <label>Address</label>
                    <div className="row row-gap-2">
                      <div className="col-12 col-md-6">
                        <Input
                          label="Street"
                          type="text"
                          placeholder="Enter Street"
                          value={organizationAddress.street}
                          onChange={(e) =>
                            setOrganizationAddress((prev) => {
                              return { ...prev, street: e.target.value };
                            })
                          }
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <Input
                          label="City"
                          type="text"
                          placeholder="Enter City"
                          value={organizationAddress.city}
                          onChange={(e) =>
                            setOrganizationAddress((prev) => {
                              return { ...prev, city: e.target.value };
                            })
                          }
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <Input
                          label="State"
                          type="text"
                          placeholder="Enter State"
                          value={organizationAddress.state}
                          onChange={(e) =>
                            setOrganizationAddress((prev) => {
                              return { ...prev, state: e.target.value };
                            })
                          }
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <Input
                          label="Country"
                          type="text"
                          placeholder="Enter Country"
                          value={organizationAddress.country}
                          onChange={(e) =>
                            setOrganizationAddress((prev) => {
                              return { ...prev, country: e.target.value };
                            })
                          }
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <Input
                          label="Zip Code / Pin Code"
                          type="number"
                          placeholder="Enter Zip Code / Pin Code"
                          value={organizationAddress.postalCode}
                          onChange={(e) =>
                            setOrganizationAddress((prev) => {
                              return { ...prev, postalCode: e.target.value };
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          )}

          {/* Step 3 */}
          {!isOrgBoarded && activeStep === 2 && (
            <div className="py-4">
              <Typography
                variant="h5"
                component="h6"
                className="text-center mb-4"
              >
                Choose Your Subscription Plan
              </Typography>
              <div className="row g-4">
                {subscriptionPlans.map((plan) => (
                  <div
                    key={plan._id}
                    className="col-12 col-md-6 col-lg-6 col-xl-4"
                  >
                    <SubscriptionCard
                      isSelected={selectedPlan._id === plan._id}
                      onSelect={setselectedPlan}
                      planData={plan}
                    />
                  </div>
                ))}
              </div>
              <div className="d-flex flex-column justify-content-center align-items-end gap-2 mt-5">
                {appliedCoupon ? (
                  <div className="mt-2 text-end">
                    <button
                      className="btn btn-outline-danger mb-3"
                      type="button"
                      onClick={() => handleRemoveCoupon()}
                    >
                      Remove
                    </button>
                    <div className="d-flex align-items-center justify-content-end gap-2">
                      <p className="fw-semibold">Original Amount:</p>
                      <p className="text-end" style={{ width: "60px" }}>
                        {appliedCoupon.originalAmount.toFixed(2)}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-2">
                      <p className="fw-semibold">Discount Amount:</p>
                      <p className="text-end" style={{ width: "60px" }}>
                        {appliedCoupon.discountAmount.toFixed(2)}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-2">
                      <p className="fw-semibold">Total :</p>
                      <p className="text-end" style={{ width: "60px" }}>
                        {appliedCoupon.finalAmount.toFixed(2)}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center gap-2">
                    <Input
                      placeholder="Coupon Code"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                    />

                    <div className="">
                      <Button
                        type="button"
                        className="rounded"
                        disabled={!couponCode}
                        onClick={handleApplyCouponCode}
                      >
                        Apply
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {!isOrgBoarded || (isOrgBoarded && activeStep !== 2) ? (
            <div className="d-flex justify-content-between flex-row-reverse new-fake-btn">
              <div className="d-flex gap-4">
                {activeStep === 2 &&
                selectedPlan?.hasTrial &&
                selectedPlan?.trialDays ? (
                  <Button
                    type={"button"}
                    className="outlined"
                    onClick={handleStartFreeTrial}
                  >
                    Start Free Trial
                  </Button>
                ) : null}
                <Button type="button" onClick={handleNextClick}>
                  {activeStep === 2 ? "Pay" : "Save"}
                </Button>
              </div>
              {activeStep === 2 ? (
                <Button
                  type="button"
                  className="outlined"
                  disabled={activeStep === 1}
                  onClick={handleBack}
                >
                  Back
                </Button>
              ) : null}
            </div>
          ) : null}
        </form>
      </div>
    </div>
  );
};

export default Onboarding;
